import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-widget',
    targetSelector: '.module',
    name: 'widget',
    options: [
      {
        key: 'productReviews',
        value: 'Product Reviews',
      },
      {
        key: 'productBundles',
        value: 'Product Bundles',
      },
      {
        key: 'volumeDiscounts',
        value: 'Volume Discounts',
      },
      {
        key: 'stockScarcity',
        value: 'Stock Scarcity',
      },
      {
        key: 'Add to Wishlist',
        value: 'addToWishlist',
      },
      {
        key: 'goToWishlist',
        value: 'Go to Wishlist',
      },
      {
        key: 'paymentLogos',
        value: 'Payment Logos',
      },
      {
        key: 'recentlyViewed',
        value: 'Recently Viewed',
      },
      {
        key: 'shoppableInstagramFeed',
        value: 'Shoppable Instagram Feed',
      },
      {
        key: 'trustSealsAndBadges',
        value: 'Trust Seals and Badges',
      },
    ],
    default_value: 'productReviews',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];

/**
 * Fera Review Atom Module
 */
export class GpVitals extends GpThirdParty {
  public declare $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Vitals';
  }

  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'vitals';
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  isAutoRenderSetting() {
    return true;
  }
}
